//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    productName: {
      type: String,
      required: true,
    },
    productVersionSlug: {
      type: String,
      required: true,
    },
    preview: {
      type: String,
      required: true,
    },
    overrideLink: {
      type: String,
    },
  },
  data() {
    return {
      localPreview: "",
    };
  },
  created() {
    this.localPreview = this.decodeHtml(this.preview);
  },
  computed: {
    createLink() {
      if (this.overrideLink) {
        return this.overrideLink;
      } else {
        return `/documents/new/${this.productVersionSlug}`;
      }
    },
  },
  methods: {
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
  },
};
